import type * as ApiHubSpot from './types'

import { apiRTK } from '../api-rtk'

export const hubSpotApi = apiRTK.injectEndpoints({
	endpoints: create => ({
		hubSpotSettings: create.query<ApiHubSpot.Settings, string>({
			query: id => ({
				url: `campaigns/${id}/settings/hubspot`
			})
		}),

		options: create.query<ApiHubSpot.Options[], ApiHubSpot.OptionKey>({
			query: fieldName => ({
				url: `integrations/hubspot/contacts/properties/${fieldName}/options`
			})
		}),

		updateSettings: create.mutation<
			ApiHubSpot.Settings,
			ApiHubSpot.UpdateSettingsBody
		>({
			onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
				const patchResult = dispatch(
					hubSpotApi.util.updateQueryData('hubSpotSettings', id, draft =>
						Object.assign(draft, patch)
					)
				)

				queryFulfilled.catch(patchResult.undo)
			},

			query: ({ id, ...data }) => ({
				data,
				method: 'PUT',
				url: `campaigns/${id}/settings/hubspot`
			})
		})
	}),
	overrideExisting: true
})
